import React from "react"
import { Link } from "react-router-dom"

const SectionFive = () => {
  return (
    <div className="h-screen gift-bottom mobiles:mt-96 mobiles:relative mobiles:top-44 text-center pb-20">
      <div className="global-container">
        <h4 className="text-5xl mobiles:text-4xl sabi-header">
          Mad<span className="header-bg-design sabi-header">e just</span> for
          you
        </h4>
        <p className="mt-8 text-xl">Why you need to join us</p>
        <div className="mt-40 mobiles:mt-24 px-10 mobiles:px-2 grid grid-cols-3 gap-8 mobiles:block h-60vh">
          <div className="rounded-md shadow mobiles:mb-12 mobiles:pb-28 h-full bg-white border border-gray-200 px-8">
            <img
              src={require("../../assets/easiest-way.svg").default}
              alt=""
              className="w-24 mt-20 mx-auto block"
            />
            <h6 className="text-lg mt-8 font-semibold">Easiest way</h6>
            <p className="mt-8 ">
              We take the guesswork out of registering with handy tools like our
              checklist and your registry advisor
            </p>
          </div>
          <div className="rounded-md shadow mobiles:mb-12 mobiles:pb-28 h-full bg-white border border-gray-200 px-8">
            <img
              src={require("../../assets/our-store.svg").default}
              alt=""
              className="w-24 mt-20 mx-auto block"
            />
            <h6 className="text-lg mt-8 font-semibold">Our Store has it all</h6>
            <p className="mt-8 ">
              Only place with classic and unique wedding gifts, giftcards and
              honeymoon funds all in one.
            </p>
          </div>
          <div className="rounded-md shadow mobiles:pb-28 h-full mobiles:mb bg-white border border-gray-200 px-8">
            <img
              src={require("../../assets/smarter-exchange.svg").default}
              alt=""
              className="w-24 mt-20 mx-auto block"
            />
            <h6 className="text-lg mt-8 font-semibold">Smarter Exchanges</h6>
            <p className="mt-8 ">
              Only place with classic and unique wedding gifts, giftcards and
              honeymoon funds all in one.
            </p>
          </div>
        </div>
        <div className="mt-60 mobiles:transform mobiles:translate-y-96 mobiles:relative mobiles:top-96">
          <Link
            // to="/sign-up"
            className=" py-2.5 px-11 bg-sbg-light-green border border-transparent text-transparent rounded-md text-base text-white "
          >
            Get Started
          </Link>
        </div>
      </div>
      <div className="mobiles:mt-48 mobiles:transform mobiles:translate-y-96 mobiles:relative mobiles:top-96">
        {/* <img
					src={require("../../assets/gift-bottom.svg").default}
					className="block relative -top-48"
					style={{ width: "2500px", transform: "translateX(10%)" }}
				/> */}
      </div>
    </div>
  )
}

export default SectionFive
